<template>
    <el-tree :data="departmentlist" node-key="id" default-expand-all :expand-on-click-node="false"
        @node-click="onSelect">
        <div class="custom-tree-node" slot-scope="{ node, data }" :class="{
            activeThree:
                (!department_id &&
                    department_id === data.department_id) ||
                (!user_id && user_id === data.user_id),
        }">
            <img :src="data.department_id
                ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxCAYAAACcXioiAAAAAXNSR0IArs4c6QAABAhJREFUaEPtmWtSGkEQx7sXdoESzHqC4A30BnKC6AmCJwh+My5VrlWC+RZzgugJYk4gNwg5gdyAFYiysGynFgO1jxlm9qGWKfgIMz3/33ZPPxaEN/7BN64f1gCv7cG1B/4LDxTNx6rjONUFTDlf7lomWi8BlyqEtM+DfVTwEwDsMcR2XMKjabvcfU6QxADFk+EpIZgicURgTtqVM9G6pL8nApAVvxBFLh1MLjZvkopctS82gBfvNHXuYoqxSqqzbZlbgXuhm6SPYazPJjN9Q9voJbk3sQE0Y3CFgB9jAgAAHtmt8uViX/G4X6VcPvwgOqjmD8dmqSdrPwHAsI8AuuwBvnUdu1Wp+fcVjeEtMRIAAtbHrfK1zBmxAIrN4R4R3MoYZqyx7FZly/99oTm8BAIvi4U/zJBjnRsLoGCMGgD0NSEA4MzZHn/ZWoaHejKoK4jfWfYI4WxyXhFmuVgAWnNoIsFpUoAZQs05r3QW+7XmYB8Jf3DsRTyW2gNpAVzCXX9hEwBEPJYaYJXLZbxSUp0tfyoVhWTYY6kBsr7EopScOQCYfb0wzfdlnnZkDWLHPi8H0mjBGP0CoB2evXDIpfaAZ4CXu0VQSHQ4bm9eLQuZREUPh1w2ACeDOnFSHx8Cezib1vwpVBQ+wPBYJgCekYIxugOgZf8vevrhnP7UT81uV9kIe4x3Rqw6sHR/rIqMPbtV3vYLEHez0T2ZAszvQnNokrCoRUNHppvNuXTwINl+J/LA4mmUjPuGCwqntYiK99rnx+kfL/Nww0+2hVhoSAXgGdEMXncabJ+9tapx31C4wABA9NNub+6L7pT/92cDYD3JoiCDEeDVpFU+fBGAp3AYeY1dg3ug6x7ZF++WQ8z87swhlFNuGDH2rAKK7QFP+MNk9AkQGnKDDfZccs+mviL2LwnsuUR19nTH3pOqDsQXHj6OA3Lcr7q5nJkUROiB9MKjIER0pWj5a//s+9RaexmNlaGwh2quxpqVuQDZC5fwiNnXtWnukvfSgDUrMwFkSn2cTLFyLcFNSXMO/XPCqiIZbrEjAOrJaAeRbuUuaGYY3ZLq1ALDDn/gD7zdCADIVMrMJIcMRerGfPZQWVU7MCsHANKOjOngog0cb2a2W5Wl7gBAwRjcAOCHdEKS746MkJwJkA2QZlxMrjm4k+Cb3a4EKntg9kDsoOte+ye7pQc47yqzkiZlh9ULPbUepKOq3QjrQNJ5V0qdYBEBWMrM2fWPnTJ2I2lU2GzJWI2xxhOOqHTQmRzFFe8dw63E83qguFV0cQ8U5T0C6URQjTML+znmQgEtROgBYo9c5zei0i3mnW74f4MY/Mn/6PaqtcxBRRhbaQSKzhA2cyIDr/37GmDtgZRP4M2H0F8NWCxQ9JzTmAAAAABJRU5ErkJggg=='
                : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAjJJREFUWEftmN9NKkEUh78DCfHNawfYgVYgdOCtAEgM6puWYAe+EdQE6AAr0A6kA+lAfNUsY2Z2Udjlz5xZvBCvkxAeOLP7zW/OmfMbhC0fsuV8/D+ApsMfcB+kwXBdO5NbQdOiTpEahsoMlPAI9KRJNw9sMKBpUaZIJwOWpRkypirnYaoGATq4Ag9A2VOdYMgwwDbPCrh4DcKjNKl6LugzTA3ocq5AR/uiJP6vnNLXzNUD3vDgkXfzGQJU1AO2MRoFUrEjOWVPM18FmBSHzb/wMWZfU9H/HrDEnjQY+a5QBWgfatq8TDqG70um4r53ix1gniIx3MsZx5qF6RVsUUkOac174ti4o9gW6D3UgMEqCl1p0vAmSwLDAK1zeeNJ0U2GlDjUFMdkIUGATsUY8hqorVClT4lGCJx9bjDgBMrEOVkHjqYUHSH0iehpcy692NyA2pzSxv9sQNOhTMQBEWXEecPdRKFXDCOKDHhnoGltubbYFca7O2iPMO7b3UE8xtD6QQrcy8k32K3E3l9gXMX6Qi3inhTQlY+yS3NQcZR4iDgnROgSsRR0IaBpuy20zjmvYqvg7RX1cpHTngto7qgR5bsurqLK/F6kLif0VhbJWkypmu6z8R5Kk8H09IyCuexUKNhX483c/GYAk6KwhnRzI+W4ZwFvqTB2F/LNDWFmm7cPMGVqfwHVubJUwdiEbrZIUvfm7DFj/7ny/9dKLdDSCTsM0s77Z/vB9co3/2lbr+AHM2OyKfTIYLcAAAAASUVORK5CYII='
                " alt="" />
            <span>{{ data.department_name || data.real_name }}</span>
        </div>
    </el-tree>
</template>
<script>
export default {
    props: {
        departmentlist: {
            type: Array,
            default() {
                return []
            }
        },
        department_id: {
            type: String,
            default: ''
        },
        user_id: {
            type: String,
            default: ''
        }
    },
    methods: {
        onSelect(info) {
            this.$emit('onSelect', info)
        }
    }
}
</script>
<style scoped>
.activeThree {
    width: 100%;
    background: rgba(7, 123, 243, 0.1);
}

.custom-tree-node img {
    margin-right: 5px;
    width: 16px;
    height: 16px;
}
</style>